import { formatAndRaiseError } from "../../helpers/general";
import { requestHelper } from "../../helpers/request-helper";

export function retrieve_cart_fetcher() {
  return requestHelper(`query cart{
    retrieveCart{
      id
      legacyPromotion{
        code
        description
      }
      legacyQuote{
        logistic_price      
        discount
        total_items_amount
        total_amount
        total_price
        vat
        tax
        toll
        cash_back
        total_extra_charge
      }
      items{
        id
        service
        variation
        coefficient
        discount
      }
      services{
        id
        alias
        name
        display_name
        description
        unit
        pricing{
          id
          price
          variation{
            id
            alias
            name
            display_name
          }
        }
      }
    }
  }`)
    .then((data) => {
      if (data && data.retrieveCart) {
        return data.retrieveCart;
      }
      return data;
    })
    .catch(formatAndRaiseError);
}
